<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_vii"></a><strong><span class="small">CONTENTS</span></strong></h2>
<p class="toc-pref"><a class="nounder" href="#/xhtml/intro#intro">Introduction</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01#ch01">1 What Is Hanukkah?</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 Modern Maccabees</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 Children Light Up</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Remade in America</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Homegrown Heroism</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Forging a Common Tradition</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Hippies, Hasidim, and Havurot</span></p>
<p class="toc-prefz"><span class="nounder" href="#/xhtml/conclusion#conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-app"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc-app"><span class="nounder" href="#/xhtml/note#note" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-app"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc-app"><span class="nounder" href="#/xhtml/author#author" title="Link target outside of Sample"><em>About the Author</em></span></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b79d85b8